import PlanningOffers from "./PlanningOffers";

export default PlanningOffers;